// 表单属性【右面板】
export const formConf = {
  formRef: 'elForm',
  formModel: 'formData',
  size: 'medium',
  labelPosition: 'top',
  labelWidth: 100,
  formRules: 'rules',
  gutter: 16,
  disabled: false,
  span: 24,
  formBtns: true
}
// 图标
export const imgType = {
  '单行文本': require('@/assets/form/input.png'),
  '多行文本': require('@/assets/form/textarea.png'),
  '计数器': require('@/assets/form/input-number.png'),
  '下拉框': require('@/assets/form/select.png'),
  '复选框': require('@/assets/form/checkbox.png'),
  '单选框': require('@/assets/form/radio.png'),
  '开关': require('@/assets/form/switch.png'),
  '日期选择': require('@/assets/form/date.png'),
  '日期范围': require('@/assets/form/date-range.png'),
  '时间选择': require('@/assets/form/time.png'),
  '时间范围': require('@/assets/form/time-range.png'),
  '评分': require('@/assets/form/rate.png'),
  '上传': require('@/assets/form/upload.png'),
  '行容器': require('@/assets/form/row.png'),
  '人员': require('@/assets/form/person.png'),
  '部门': require('@/assets/form/department.png'),
  '角色': require('@/assets/form/role.png'),
  '多列': require('@/assets/form/row.png'),
  '说明文本': require('@/assets/form/text.png'),
  '系统变量': require('@/assets/form/system.png'),
  '查询统计': require('@/assets/form/statistics.png'),
  '关联审批': require('@/assets/form/approve.png'),
  '明细表': require('@/assets/form/form.png'),
  '计算公式': require('@/assets/form/calc.png')
}
export const compType = {
  1: 'input', // 单行文本
  2: 'textarea', // 多行文本
  3: 'input-number', // 计数器
  4: 'select', // 下拉选择
  5: 'select-multiply', // 下拉选择（多选）
  6: 'checkbox', // 复选框（多选）
  7: 'radio', // 单选框
  8: 'switch', // 开关
  9: 'date', // 日期
  10: 'date-range', // 日期范围（数组）
  11: 'time', // 时间
  12: 'time-range', // 时间范围（数组）
  13: 'rate', // 评分
  14: 'upload-image', // 图片上传（数组）
  15: 'upload-file', // 附件上传（数组）
  16: 'person', // 人员组件（数组）
  17: 'department', // 部门组件（数组）
  18: 'role', // 角色组件（数组）
  19: 'time-range-times', // 日期选择带时间
  20: 'date-range-times', // 日期范围选择带时间(数组)
  21: 'text', // 说明文本
  22: 'system', // 系统变量
  23: 'statistics', // 查询统计
  24: 'approve', // 关联审批
  25: 'form', // 明细表
  26: 'calc' // 计算公式
}
export const compDefaultValue = {
  1: '', // 单行文本
  2: '', // 多行文本
  3: undefined, // 计数器
  4: undefined, // 下拉选择
  5: undefined, // 下拉选择（多选）
  6: [], // 复选框（多选）
  7: undefined, // 单选框
  8: '否', // 开关
  9: null, // 日期
  10: null, // 日期范围（数组）
  11: null, // 时间
  12: null, // 时间范围（数组）
  13: 0, // 评分
  14: [], // 图片上传（数组）
  15: [], // 附件上传（数组）
  16: [], // 人员组件（数组）
  17: [], // 部门组件（数组）
  18: [], // 角色组件（数组）
  19: null, // 日期选择带时间
  20: null, // 日期范围选择带时间(数组)
  21: '', // 说明文本
  22: '', // 系统变量
  23: null, // 查询统计
  24: [], // 关联审批
  25: [], // 明细表
  26: '' // 计算公式
}
// 输入型组件 【左面板】
export const inputComponents = [
  {
    // 组件的自定义配置
    bpmConfig: {
      label: '单行文本',
      desc: '',
      labelWidth: 100,
      showLabel: true,
      changeTag: true,
      tag: 'el-input',
      tagIcon: 'input',
      defaultValue: '',
      required: true,
      layout: 'colFormItem',
      span: 24,
      // 正则校验规则
      regList: [],
      conditionList: [],
      regExp: '' // 正则规则，单选
    },
    // 组件的插槽属性
    bpmSlot: {
      prepend: '',
      append: ''
    },
    // 其余的为可直接写在组件标签上的属性
    placeholder: '请输入',
    style: { width: '100%' },
    clearable: true,
    'prefix-icon': '',
    'suffix-icon': '',
    maxlength: 500,
    'show-word-limit': true,
    readonly: false,
    disabled: false,
    compType: 1
  },
  {
    bpmConfig: {
      label: '多行文本',
      desc: '',
      labelWidth: 100,
      showLabel: true,
      tag: 'el-input',
      tagIcon: 'textarea',
      defaultValue: '',
      required: true,
      layout: 'colFormItem',
      span: 24,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    type: 'textarea',
    placeholder: '请输入',
    autosize: {
      minRows: 4,
      maxRows: 4
    },
    style: { width: '100%' },
    maxlength: 1000,
    'show-word-limit': true,
    readonly: false,
    disabled: false,
    compType: 2
  },
  {
    bpmConfig: {
      label: '计数器',
      desc: '',
      showLabel: true,
      changeTag: true,
      labelWidth: 100,
      tag: 'el-input-number',
      tagIcon: 'number',
      defaultValue: undefined,
      span: 24,
      layout: 'colFormItem',
      required: true,
      conditionList: [],
      regList: []
    },
    placeholder: '请输入',
    min: 0,
    max: undefined,
    step: 1,
    'step-strictly': false,
    precision: undefined,
    'controls-position': 'right',
    disabled: false,
    compType: 3
  }
]

// 选择型组件 【左面板】
export const selectComponents = [
  {
    bpmConfig: {
      label: '下拉框',
      desc: '',
      showLabel: true,
      defaultValue: undefined,
      labelWidth: 100,
      tag: 'el-select',
      tagIcon: 'select',
      layout: 'colFormItem',
      span: 24,
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    bpmSlot: {
      options: [{
        label: '选项名一',
        value: '选项值一'
      }, {
        label: '选项名二',
        value: '选项值二'
      }]
    },
    placeholder: '请选择',
    style: { width: '100%' },
    clearable: true,
    disabled: false,
    filterable: true,
    multiple: false,
    compType: 4
  },
  // {
  //   bpmConfig: {
  //     label: '级联选择',
  //     url: 'https://www.fastmock.site/mock/f8d7a54fb1e60561e2f720d5a810009d/fg/cascaderList',
  //     method: 'get',
  //     dataPath: 'list',
  //     dataConsumer: 'options',
  //     showLabel: true,
  //     labelWidth: 100,
  //     tag: 'el-cascader',
  //     tagIcon: 'cascader',
  //     layout: 'colFormItem',
  //     defaultValue: [],
  //     dataType: 'static',
  //     span: 24,
  //     required: true,
  //     regList: [],
  //     changeTag: true,
  //   },
  //   options: [{
  //     id: 1,
  //     value: 1,
  //     label: '选项1',
  //     children: [{
  //       id: 2,
  //       value: 2,
  //       label: '选项1-1'
  //     }]
  //   }],
  //   placeholder: '请选择',
  //   style: { width: '100%' },
  //   props: {
  //     props: {
  //       multiple: false,
  //       label: 'label',
  //       value: 'value',
  //       children: 'children'
  //     }
  //   },
  //   'show-all-levels': true,
  //   disabled: false,
  //   clearable: true,
  //   filterable: false,
  //   separator: '/'
  // },
  {
    bpmConfig: {
      label: '复选框',
      desc: '',
      tag: 'el-checkbox-group',
      tagIcon: 'checkbox',
      defaultValue: [],
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      optionType: 'default',
      required: true,
      regList: [],
      changeTag: true,
      conditionList: [],
      border: false
    },
    bpmSlot: {
      options: [{
        label: '选项名一',
        value: '选项值一'
      }, {
        label: '选项名二',
        value: '选项值二'
      }]
    },
    style: {},
    size: 'medium',
    min: null,
    max: null,
    disabled: false,
    compType: 6
  },
  {
    bpmConfig: {
      label: '单选框',
      desc: '',
      labelWidth: 100,
      showLabel: true,
      tag: 'el-radio-group',
      tagIcon: 'radio',
      changeTag: true,
      defaultValue: undefined,
      layout: 'colFormItem',
      span: 24,
      optionType: 'default',
      regList: [],
      required: true,
      conditionList: [],
      border: false
    },
    bpmSlot: {
      options: [{
        label: '选项名一',
        value: '选项值一'
      }, {
        label: '选项名二',
        value: '选项值二'
      }]
    },
    style: {},
    size: 'medium',
    disabled: false,
    compType: 7
  },
  {
    bpmConfig: {
      label: '开关',
      desc: '',
      tag: 'el-switch',
      tagIcon: 'switch',
      defaultValue: '否',
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    style: {},
    disabled: false,
    'active-text': '',
    'inactive-text': '',
    'active-color': null,
    'inactive-color': null,
    'active-value': '是',
    'inactive-value': '否',
    compType: 8
  },
  // {
  //   bpmConfig: {
  //     label: '滑块',
  //     tag: 'el-slider',
  //     tagIcon: 'slider',
  //     defaultValue: null,
  //     span: 24,
  //     showLabel: true,
  //     layout: 'colFormItem',
  //     labelWidth: 100,
  //     required: true,
  //     regList: [],
  //     changeTag: true,
  //   },
  //   disabled: false,
  //   min: 0,
  //   max: 100,
  //   step: 1,
  //   'show-stops': false,
  //   range: false
  // },
  {
    bpmConfig: {
      label: '日期选择',
      desc: '',
      tag: 'el-date-picker',
      tagIcon: 'date',
      defaultValue: null,
      showLabel: true,
      labelWidth: 100,
      span: 24,
      layout: 'colFormItem',
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true,
      allowHistory: true
    },
    placeholder: '请选择',
    type: 'date',
    style: { width: '100%' },
    disabled: false,
    clearable: true,
    format: 'yyyy-MM-dd',
    'value-format': 'yyyy-MM-dd',
    readonly: false,
    compType: 9
  },
  {
    bpmConfig: {
      label: '日期范围',
      desc: '',
      tag: 'el-date-picker',
      tagIcon: 'date-range',
      defaultValue: null,
      span: 24,
      showLabel: true,
      labelWidth: 100,
      required: true,
      layout: 'colFormItem',
      regList: [],
      conditionList: [],
      changeTag: true,
      allowHistory: true
    },
    style: { width: '100%' },
    type: 'daterange',
    'range-separator': '至',
    'start-placeholder': '开始日期',
    'end-placeholder': '结束日期',
    disabled: false,
    clearable: true,
    format: 'yyyy-MM-dd',
    'value-format': 'yyyy-MM-dd',
    readonly: false,
    compType: 10
  },
  {
    bpmConfig: {
      label: '时间选择',
      desc: '',
      tag: 'el-time-picker',
      tagIcon: 'time',
      defaultValue: null,
      span: 24,
      showLabel: true,
      layout: 'colFormItem',
      labelWidth: 100,
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    placeholder: '请选择',
    style: { width: '100%' },
    disabled: false,
    clearable: true,
    'picker-options': {
      selectableRange: '00:00:00-23:59:59'
    },
    format: 'HH:mm:ss',
    'value-format': 'HH:mm:ss',
    compType: 11
  },
  {
    bpmConfig: {
      label: '时间范围',
      desc: '',
      tag: 'el-time-picker',
      tagIcon: 'time-range',
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      defaultValue: null,
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    style: { width: '100%' },
    disabled: false,
    clearable: true,
    'is-range': true,
    'range-separator': '至',
    'start-placeholder': '开始时间',
    'end-placeholder': '结束时间',
    format: 'HH:mm:ss',
    'value-format': 'HH:mm:ss',
    compType: 12
  },
  {
    bpmConfig: {
      label: '评分',
      desc: '',
      tag: 'my-rate',
      tagIcon: 'rate',
      defaultValue: 0,
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      conditionList: [],
      changeTag: true
    },
    style: {},
    max: 5,
    'allow-half': false,
    'show-text': false,
    'show-score': false,
    disabled: false,
    compType: 13
  },
  {
    bpmConfig: {
      label: '上传',
      desc: '',
      tag: 'el-upload',
      tagIcon: 'upload',
      layout: 'colFormItem',
      defaultValue: [],
      showLabel: true,
      labelWidth: 100,
      required: true,
      span: 24,
      showTip: true,
      buttonText: '点击上传',
      fileList: '',
      regList: [],
      changeTag: true,
      fileSize: 2,
      conditionList: [],
      sizeUnit: 'MB'
    },
    bpmSlot: {
      'list-type': true
    },
    action: 'https://jsonplaceholder.typicode.com/posts/',
    disabled: false,
    accept: 'image/*',
    name: 'file',
    'auto-upload': true,
    'list-type': 'picture-card',
    multiple: false,
    compType: 14
  }
]

// 布局型组件 【左面板】
export const layoutComponents = [
  {
    bpmConfig: {
      layout: 'rowFormItem',
      tagIcon: 'row',
      label: '行容器',
      layoutTree: true
    },
    type: 'default',
    justify: 'start',
    align: 'top'
  },
  {
    bpmConfig: {
      desc: '',
      actionName: '添加明细',
      layout: 'rowFormItem',
      tag: 'my-form',
      tagIcon: 'my-form',
      label: '明细表',
      labelWidth: 100,
      defaultValue: [],
      layoutTree: true,
      children: [],
      changeTag: true,
      showLabel: true,
      direction: 'row',
      conditionList: [],
      regList: [],
      required: true
    },
    type: 'default',
    justify: 'start',
    align: 'top',
    compType: 25
  }
]

export const highComponents = [
  {
    placeholder: '请选择',
    bpmConfig: {
      authList: [], // 指定人员部门回显数据
      isSearch: false, // 纯搜索模式
      label: '人员',
      desc: '',
      tag: 'my-person',
      tagIcon: 'my-person',
      defaultValue: [],
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      conditionList: [],
      changeTag: true,
      islimitUser: false, // 人员限制
      limitUserList: [],
      islimitDept: false, // 部门限制
      limitDeptList: [], // 部门限制列表
      limitRolesList: [] // 角色限制
    },
    style: { width: '100%' },
    disabled: false,
    compType: 16
  },
  {
    placeholder: '请选择',
    bpmConfig: {
      label: '部门',
      desc: '',
      tag: 'my-department',
      tagIcon: 'my-department',
      defaultValue: [],
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      conditionList: [],
      changeTag: true
    },
    style: { width: '100%' },
    disabled: false,
    compType: 17
  },
  {
    placeholder: '请选择',
    bpmConfig: {
      label: '角色',
      desc: '',
      tag: 'my-role',
      tagIcon: 'my-role',
      defaultValue: [],
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      conditionList: [],
      changeTag: true
    },
    style: { width: '100%' },
    disabled: false,
    compType: 18
  },
  {
    placeholder: undefined,
    bpmConfig: {
      label: '查询统计',
      desc: undefined,
      tag: 'my-statistics',
      tagIcon: 'my-statistics',
      defaultValue: null,
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: false,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      changeTag: true,
      statisticsTmpId: '',
      statisticsTmp: {}, // 查询统计选中的模板
      filterFields: [], // 查询统计选中设置的过滤字段与表单字段
      conditionList: []
    },
    style: { width: '100%' },
    disabled: false,
    compType: 23
  },
  {
    placeholder: undefined,
    bpmConfig: {
      label: '关联审批',
      desc: undefined,
      tag: 'my-approve',
      tagIcon: 'my-approve',
      defaultValue: [],
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: true,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      changeTag: true,
      conditionList: [],
      approvalType: [] // 关联审批选中的流程类型
    },
    style: { width: '100%' },
    disabled: false,
    compType: 24
  },
  {
    placeholder: undefined,
    bpmConfig: {
      label: '计算公式',
      desc: '',
      tag: 'my-calc',
      tagIcon: 'my-calc',
      defaultValue: '',
      span: 24,
      showLabel: true,
      showDecimal: true, // 显示小数位
      unit: '', // 单位
      showPercent: false, // 显示百分比
      showPercentile: false, // 显示千分位符
      labelWidth: 100,
      digits: 2,
      layout: 'colFormItem',
      required: false,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      changeTag: true,
      conditionList: [],
      setting: {} // 公式配置
    },
    style: { width: '100%' },
    disabled: false,
    compType: 26
  }
]
export const assistComponents = [
  {
    placeholder: undefined,
    bpmConfig: {
      label: '说明文本',
      desc: '',
      tag: 'my-text',
      tagIcon: 'my-text',
      defaultValue: '',
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: false,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      conditionList: [],
      changeTag: true
    },
    style: { width: '100%' },
    disabled: false,
    compType: 21
  },
  {
    placeholder: undefined,
    bpmConfig: {
      label: '系统变量',
      desc: '',
      tag: 'my-system',
      tagIcon: 'my-system',
      defaultValue: '',
      systemVariable: null, // 变量code
      span: 24,
      showLabel: true,
      labelWidth: 100,
      layout: 'colFormItem',
      required: false,
      regList: [],
      hideReg: true, // 隐藏正则按钮
      conditionList: [],
      changeTag: true
    },
    style: { width: '100%' },
    disabled: false,
    compType: 22
  }
]

export const ruleSelectList = [
  {
    label: '手机号码',
    value: '1',
    reg: /^1[2-9]\d{9}$/
  },
  {
    label: '数字',
    value: '2',
    reg: /^[0-9]*$/
  },
  {
    label: '整数或小数',
    value: '3',
    reg: /^-?([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
  },
  {
    label: '字母或下划线',
    value: '4',
    reg: /^[A-Za-z_]+$/
  },
  {
    label: '邮箱',
    value: '5',
    reg: /^\w+([\.\-]\w+)*\@\w+([\.\-]\w+)*\.\w+$/
  },
  {
    label: '网址',
    value: '6',
    reg: /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
  },
  {
    label: '汉字',
    value: '7',
    reg: /^[\u4e00-\u9fa5]+$/
  },
  {
    label: '不以数字开头',
    value: '8',
    reg: /^[^\d]+/
  },
  {
    label: '以字母开头',
    value: '9',
    reg: /^[a-zA-Z]+/
  }
]
